import { render, staticRenderFns } from "./admin-component.vue?vue&type=template&id=72a1ea55&scoped=true&"
import script from "./admin-component.vue?vue&type=script&lang=js&"
export * from "./admin-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a1ea55",
  null
  
)

export default component.exports